import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ListComponent } from '../list.component';
import { CustomersDataSource } from '../../datasources/customers-data-source';


@Component({
  selector: 'app-list-desktop',
  templateUrl: './list-desktop.component.html',
  styleUrls: ['./list-desktop.component.scss']
})
export class DesktopListComponent extends ListComponent implements AfterViewInit, OnInit, OnDestroy {

  dataSource: CustomersDataSource;
  displayedColumns: string[] =
    ['customerName', 'phone', 'email', 'customerType', 'salesperson', 'action'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {
    super.init();

    this.dataSource = new CustomersDataSource(this.customerService);
    this.loadCustomers();
  }
  ngAfterViewInit(): void {
    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        tap(() => this.loadCustomers())
      )
      .subscribe();

    this.paginator.page
      .pipe(
        tap(() => this.loadCustomers())
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.sort.sortChange.unsubscribe();
    this.paginator.page.unsubscribe();
  }

  loadCustomers() {
    this.dataSource.loadCustomers(this.filter, this.sort.active,
      this.sort.direction, this.paginator.pageIndex);
  }

  refreshSummary() {
    this.loadSummary();
    this.loadCustomers();
  }
}
